// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menuDropNot{
    width: 100%;
    padding: 2%;
}

.dropNot{
    background-color: #f1f4ff !important;
    border: #acacac solid 1px;
    height: 100%;
    font-size: smaller;
}

.notGral{
    background-color: #FFF !important;
    border: #acacac solid 1px;
    height: 100%;
    width: 100%;
    
}

.containerNot{
    width: 100%;
    display: flex;
    word-wrap: break-word;
}

.dateNot{
    color: rgb(133, 133, 133);
    font-size:xx-small;
    height: 20%;
    width: 20%;
    text-align: right;
}

.iconNot{
    height: 100%;
    width: 10%;
    color: #acacac;
    align-items: center; 
    justify-content: center;
    text-align: center;
}

.contentNot{
    width: 70%;
    height: 100%;
    margin-left: 1.5%;
    margin-right: 3%;
    word-wrap: break-word;
}

.labelUserNot{
    text-transform: capitalize;
}

.textPNot{
    font-weight: bold;
    margin-top: -6%;
    margin-bottom: -4%;
    font-size: small;
}

.textMotNot{
    margin-top: -3%;
    margin-bottom: -6%;
    font-style: italic;
}

.lblMsgNot, .lblEn{
    font-weight: normal !important;
}

.lblEn{
    font-style: normal;
}

@media only screen and (max-width: 600px) {
    .homeUserName{
        font-size:medium !important;
        margin-left: 10%;
        margin-right: 10%;
    }

    .rolUser{
        font-size: smaller;
        margin-top: -1% !important;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/administrador/Dashboard/styleNotifications.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,YAAY;IACZ,WAAW;;AAEf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,2BAA2B;QAC3B,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,0BAA0B;IAC9B;EACF","sourcesContent":[".menuDropNot{\n    width: 100%;\n    padding: 2%;\n}\n\n.dropNot{\n    background-color: #f1f4ff !important;\n    border: #acacac solid 1px;\n    height: 100%;\n    font-size: smaller;\n}\n\n.notGral{\n    background-color: #FFF !important;\n    border: #acacac solid 1px;\n    height: 100%;\n    width: 100%;\n    \n}\n\n.containerNot{\n    width: 100%;\n    display: flex;\n    word-wrap: break-word;\n}\n\n.dateNot{\n    color: rgb(133, 133, 133);\n    font-size:xx-small;\n    height: 20%;\n    width: 20%;\n    text-align: right;\n}\n\n.iconNot{\n    height: 100%;\n    width: 10%;\n    color: #acacac;\n    align-items: center; \n    justify-content: center;\n    text-align: center;\n}\n\n.contentNot{\n    width: 70%;\n    height: 100%;\n    margin-left: 1.5%;\n    margin-right: 3%;\n    word-wrap: break-word;\n}\n\n.labelUserNot{\n    text-transform: capitalize;\n}\n\n.textPNot{\n    font-weight: bold;\n    margin-top: -6%;\n    margin-bottom: -4%;\n    font-size: small;\n}\n\n.textMotNot{\n    margin-top: -3%;\n    margin-bottom: -6%;\n    font-style: italic;\n}\n\n.lblMsgNot, .lblEn{\n    font-weight: normal !important;\n}\n\n.lblEn{\n    font-style: normal;\n}\n\n@media only screen and (max-width: 600px) {\n    .homeUserName{\n        font-size:medium !important;\n        margin-left: 10%;\n        margin-right: 10%;\n    }\n\n    .rolUser{\n        font-size: smaller;\n        margin-top: -1% !important;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
